function subnav() {
    const subnavContainers = document.querySelectorAll('.subnav');

    subnavContainers.forEach((subnavContainer) => {
        const subnavContainerId = subnavContainer.id;
        const subnavList = document.querySelector(
            `#${subnavContainerId} .subnav__list`
        );

        if (subnavList.scrollWidth > subnavContainer.scrollWidth) {
            subnavContainer.classList.add('subnav--scrollable');
        }

        const scrollRightButton = document.querySelector(
            `#${subnavContainerId} .subnav--right`
        );
        scrollRightButton.addEventListener('click', () => {
            animateScroll(subnavList, 200, 300);
        });

        const scrollLeftButton = document.querySelector(
            `#${subnavContainerId} .subnav--left`
        );
        scrollLeftButton.addEventListener('click', () => {
            animateScroll(subnavList, -200, 300);
        });

        // scroll the subnavList to the current active item
        const activeItem = document.querySelector(
            `#${subnavContainerId} .subnav__list li.active`
        );
        if (activeItem) {
            subnavList.scrollLeft = activeItem.offsetLeft - 90;
        }
        // trigger scroll event on subnavList to check if scroll buttons should be shown
        setTimeout(() => {
            // timeout is required so that the scroll event is triggered after the active item is scrolled into view
            subnavList.dispatchEvent(new Event('scroll'));
        }, 0);

        // on horizontal scroll of subnavList, check if I am on the very beginning or very end of the scroll and hide the corresponding button
        subnavList.addEventListener('scroll', () => {
            if (subnavList.scrollLeft === 0) {
                scrollLeftButton.classList.remove('can-scroll');
            } else if (window.innerWidth >= 740) {
                scrollLeftButton.classList.add('can-scroll');
            }

            if (
                Math.abs(
                    subnavList.scrollLeft +
                        subnavList.offsetWidth -
                        subnavList.scrollWidth
                ) <= 5
            ) {
                // remove right scroll if we're within 5 pixels of the end
                scrollRightButton.classList.remove('can-scroll');
            } else if (window.innerWidth >= 740) {
                scrollRightButton.classList.add('can-scroll');
            }
        });
    });
}

function animateScroll(element, amount, duration) {
    const start = element.scrollLeft;
    const startTime = performance.now();

    function scroll() {
        const currentTime = performance.now();
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        element.scrollLeft = start + amount * progress;

        if (progress < 1) {
            requestAnimationFrame(scroll);
        }
    }

    requestAnimationFrame(scroll);
}

export { subnav };
